import React from "react";
import { TinyHost } from "./types";

const TinyHostContext = React.createContext<TinyHost | undefined>(undefined);

export function TinyHostProvider({
  host,
  children,
}: {
  host: TinyHost;
  children: React.ReactNode;
}) {
  return (
    <TinyHostContext.Provider value={host}>{children}</TinyHostContext.Provider>
  );
}

export function useTinyHost(): TinyHost {
  const host = React.useContext(TinyHostContext);
  if (!host) {
    throw new Error(
      "useTinyHost must be used inside <TinyHostProvider> — the host app must mount it with its TinyHost implementation."
    );
  }
  return host;
}
